import { t } from 'localization/utils/t';

const TP = 'productTemplate.enums.translation';

export const localizeFitFeedback = (text?: string) => {
  if (!text || typeof text !== 'string') {
    return text;
  }
  switch (text?.toLowerCase()) {
    case 'knee-length':
      return t(`${TP}.kneeLength`, 'knee-length');
    case 'long':
      return t(`${TP}.long`, 'long');
    case 'midi':
      return t(`${TP}.midi`, 'midi');
    case 'mini':
      return t(`${TP}.mini`, 'mini');
    case 'relaxed fit':
      return t(`${TP}.relaxedFit`, 'relaxed fit');
    case 'tight fit':
      return t(`${TP}.tightFit`, 'tight fit');
    default:
      return text;
  }
};

export const localizeSize = (text?: string) => {
  if (!text || typeof text !== 'string') {
    return text;
  }
  switch (text?.toLowerCase()) {
    case 'one size':
      return t(`${TP}.oneSize`, 'one size');
    default:
      return text;
  }
};
